// frontend/src/pages/DeliveryForm.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { DeliveryApi, PartnerApi } from "../lib/api";

export default function DeliveryForm() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: partners } = useQuery({ queryKey: ["partners"], queryFn: () => PartnerApi.list() });
  const [form, setForm] = useState({ name: "", partnerId: "", type: "out", origin: "" });

  const mut = useMutation({
    mutationFn: () => DeliveryApi.create({ name: form.name, partnerId: parseInt(form.partnerId) || null, type: form.type, origin: form.origin }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["deliveries"] }); navigate("/deliveries"); },
  });

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="text-2xl font-bold mb-6">New Delivery</h1>
      <form onSubmit={(e) => { e.preventDefault(); mut.mutate(); }} className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Reference *</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500">
            <option value="out">Delivery (out)</option>
            <option value="in">Receipt (in)</option>
            <option value="internal">Internal Transfer</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Customer</label>
          <select value={form.partnerId} onChange={(e) => setForm({ ...form, partnerId: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500">
            <option value="">Select...</option>
            {partners?.map((p: any) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Source Document</label>
          <input value={form.origin} onChange={(e) => setForm({ ...form, origin: e.target.value })}
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div className="flex gap-3 pt-2">
          <button type="submit" disabled={mut.isPending}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {mut.isPending ? "Saving..." : "Create"}
          </button>
          <button type="button" onClick={() => navigate("/deliveries")}
            className="px-6 py-2 border rounded-lg hover:bg-gray-50">Cancel</button>
        </div>
      </form>
    </div>
  );
}
